export const VIDEO_PROVIDERS = {
  youtube: {
    providerName: 'YouTube',
    modalTitle: 'Add YouTube Video',
    menuLabel: 'Add YouTube Video',
    urlLabel: 'YouTube URL *',
    urlPlaceholder: 'Enter YouTube URL (e.g., https://www.youtube.com/watch?v=...)',
    urlValidation: {
      required: 'YouTube URL is required',
      pattern: {
        value: /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+$/,
        message: 'Please enter a valid YouTube URL',
      },
    },
    successMessage: 'YouTube video added successfully',
    errorMessage: 'Failed to add YouTube video',
  },
  wistia: {
    providerName: 'Wistia',
    modalTitle: 'Add Wistia Video',
    menuLabel: 'Add Wistia Video',
    urlLabel: 'Wistia Link *',
    urlPlaceholder: 'Enter Wistia URL (e.g., https://yourcompany.wistia.com/medias/abc123)',
    urlValidation: {
      required: 'Wistia URL is required',
      pattern: {
        value: /^https?:\/\/([a-zA-Z0-9-]+)\.wistia\.com\/medias\/([a-zA-Z0-9]+)$/,
        message: 'Please enter a valid Wistia URL (e.g., https://yourcompany.wistia.com/medias/abc123)',
      },
    },
    successMessage: 'Wistia video added successfully',
    errorMessage: 'Failed to add Wistia video',
  },
};
